import { render, staticRenderFns } from "./div-son.vue?vue&type=template&id=00becf74&scoped=true"
import script from "./div-son.vue?vue&type=script&lang=js"
export * from "./div-son.vue?vue&type=script&lang=js"
import style0 from "./div-son.vue?vue&type=style&index=0&id=00becf74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00becf74",
  null
  
)

export default component.exports